export const DASHBOARD_FILTERS = {
  STATUS_ARRAY: [
    { label: "Open", data: 0, color: 3, name: "" },
    { label: "In Progress", data: 0, color: 4, name: "" },
    { label: "Reopened", data: 0, color: 1 },
    { label: "Resolved", data: 0, color: 5, name: "" },
    { label: "Pending On Client", data: 0, color: 2, name: "" },
  ],
  TASK_COUNTS: [
    { label: "Completed", data: 0, color: 5, name: "" },
    { label: "Pending On Client", data: 0, color: 2, name: "" },
    { label: "Pending", data: 0, color: 3, name: "" },
    { label: "Over Due", data: 0, color: 1, name: "" },
  ],

  PRIORITY_ARRAY: [
    { label: "Critical", data: 0, color: 1, name: "" },
    { label: "High", data: 0, color: 2, name: "" },
    { label: "Medium", data: 0, color: 3, name: "" },
    { label: "Low", data: 0, color: 4, name: "" },
  ],

  IMPPRIORITY_ARRAY: [
    { label: "Medium", data: 0, color: 3, name: "" },
    { label: "Low", data: 0, color: 4, name: "" },
    { label: "High", data: 0, color: 2, name: "" },
    { label: "Critical", data: 0, color: 1, name: "" },
  ],

  QUICK_STATUS_OPTIONS: [
    {
      label: "In Process",
      value: "I",
    },
    {
      label: "Created",
      value: "C",
    },
    {
      label: "Pending on Client",
      value: "Q",
    },
    {
      label: "Resolved",
      value: "R",
    },
  ],

  QUICK_STATUS_DAYS_OPTIONS: [
    {
      label: "1 day",
      value: "1",
    },
    {
      label: "2 days",
      value: "2",
    },

    {
      label: "3 days",
      value: "3",
    },
    {
      label: "5 days",
      value: "5",
    },

    {
      label: "7 days",
      value: "7",
    },
    {
      label: "10 days",
      value: "10",
    },

    {
      label: "15 days",
      value: "15",
    },

    {
      label: "20 days",
      value: "20",
    },
    {
      label: "1 month",
      value: "30",
    },
    {
      label: "6 months",
      value: "180",
    },

    {
      label: "1 year",
      value: "365",
    },

    {
      label: "All years",
      value: "8000",
    },
  ],
};
